import RestApiModel from "@/api/Model/RestApiModel";

class EmailAddress extends RestApiModel {
  static getResourceEndpoint() {
    return '/AvailableEmail';
  }
}

export default EmailAddress;
